module.exports = __webpack_public_path__ + "static/media/violin.e4e88d9a.svg";